import { fromJS } from "immutable";

const initialState = fromJS({
  adminSearchData: {
    httpHeaders: "",
    isLoading: true,
    data: null,
    error: ""
  }
});

const adminSearch = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ADMINSEARCH_LOADING":
      return state
        .setIn(["adminSearchData", "isLoading"], true)
        .setIn(["adminSearchData", "error"], "");
    case "GET_ADMIN_SEARCH_RESULTS_SUCCESS":
      return state
        .setIn(["adminSearchData", "data"], action.payload.data)
        .setIn(["adminSearchData", "httpHeaders"], action.payload.headers)
        .setIn(["adminSearchData", "isLoading"], false);
    case "GET_ADMIN_SEARCH_RESULTS_ERROR":
      return state.setIn(["adminSearchData", "error"], action.payload);
    default:
      return state;
  }
};

export default adminSearch;
